<template>
  <section class="section_3">
    <div class="page-wrapper">
      <div class="content_box">
        <div class="fun-box" bg-url="@/auto/assets/image/fun-bg.png" v-bg></div>
        <div
          class="work-box"
          bg-url="@/auto/assets/image/work-bg.png"
          v-bg
        ></div>
        <div
          class="sport-box"
          bg-url="@/auto/assets/image/sport-bg.png"
          v-bg
        ></div>
        <div class="seat"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SmartBar',
  data() {
    return {
      tl: '',
    }
  },
  methods: {
    pagePin() {
      this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.page-wrapper',
          end: '+9200',
          pin: true,
        },
      })
    },

    cursorAnimation() {
      this.tl.to('.fun-box', {
        width: '100vw',
        height: '100vh',
        opacity: 1,
      })
    },

    handleWorkBoxShow() {
      console.log('handleWorkBoxShow')
      const tl = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.work-box',
          start: '2300px top',
          end: '3100px top',
          scrub: 0.1,
        },
      })

      tl.to('.work-box', { opacity: 1 })
    },
    handleSportBoxShow() {
      console.log('handleSportBoxShow')
      const tl = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.sport-box',
          start: '4600px top',
          end: '6200px top',
          scrub: 0.1,
        },
      })

      tl.to('.sport-box', { opacity: 1 })
    },
    onPreload() {
      this.tl = this.$gsap.timeline({})
      this.pagePin()
      this.cursorAnimation()
      this.handleWorkBoxShow()
      this.handleSportBoxShow()
    },
  },
}
</script>

<style lang="less" scoped>
.seat {
  height: 1000px;
  width: 100%;
}
.page-wrapper {
  height: 100vh;
  width: 100%;
  position: relative;
  background-color: #17181c;
  overflow: hidden;

  .content_box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .fun-box {
    position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // width: 355px;
    // height: 200px;
    opacity: 0;
    // background-color: #17181c;
    overflow: hidden;
    width: 100vw;
    height: 100vh;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .work-box,
  .sport-box {
    position: absolute;
    // top: 0;
    // left: 0;
    // width: 100vw;
    // height: 100vh;
    opacity: 0;
    // background-color: #17181c;
    width: 100vw;
    height: 100vh;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
